import { assoc, assocIn, curry, pipeline } from 'mori';
import { toDateString } from 'common/datetime';
import { appState } from 'state';

import { navigateReportsHash } from 'src/url-states/reports-hash';
import { getHash } from 'src/url-states/reports-transactions';
import { fetch } from 'services/pos-daily-report';

export default function changeDate(date) {
  const newDate = toDateString(date) || date;

  appState.swap((currentState) =>
    pipeline(
      assoc(currentState, 'reports/transactions/date', newDate),
      // set transactions to null, to show the loading spinner
      // until the new day has been fetched.
      curry(assocIn, ['pos', 'daily-report', newDate], null),
    ),
  );

  const hash = getHash();
  if (hash) {
    navigateReportsHash(hash);
  }
  fetch(newDate);
}
